export default "__VITE_ASSET__COOi$RXT__"